export default __webpack_public_path__ + "static/media/Complaints-Policy.e83d88df.pdf";